import { memo } from 'react';

export const LogoSmall = memo(function LogoSmall() {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none'>
      <path
        d='M23 12V23H21.0367V12C21.0367 7.01789 16.9833 2.96281 12 2.96281C7.01672 2.96281 2.96327 7.01789 2.96327 12C2.96327 14.4315 3.91382 16.7128 5.64139 18.4218C9.17942 21.9228 14.8698 21.9098 18.3897 18.3882L19.778 19.7761C17.7007 21.8555 14.9371 23 12 23C5.93407 23 1 18.0956 1 12C1 5.90443 5.93407 1 12 1C18.0659 1 23 5.9355 23 12ZM16.2814 12.0725L10.5806 7.5798L9.3659 9.12312L13.1085 12.0725L9.3659 15.0219L10.5806 16.5652L16.2814 12.0725Z'
        fill='url(#paint0_linear_1_2385)'
      />
      <defs>
        <linearGradient id='paint0_linear_1_2385' x1='23.167' y1='22.7975' x2='6.21633' y2='-3.28572' gradientUnits='userSpaceOnUse'>
          <stop stopColor='#5C0F8B' />
          <stop offset='1' stopColor='#00B5E2' />
        </linearGradient>
      </defs>
    </svg>
  );
});
